var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTicketDiscount = function SvgTicketDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.25 10.417c0-1.15.933-2.084 2.083-2.084V7.5c0-3.333-.833-4.167-4.166-4.167H5.833c-3.333 0-4.166.834-4.166 4.167v.417a2.084 2.084 0 0 1 0 4.166v.417c0 3.333.833 4.167 4.166 4.167h8.334c3.333 0 4.166-.834 4.166-4.167a2.084 2.084 0 0 1-2.083-2.083ZM7.5 12.292l5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.495 12.292h.008M7.495 7.708h.008"
  })));
};
export default SvgTicketDiscount;